export default __webpack_public_path__ + "static/media/fileCopy.49cc3d4b.svg";